// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"c718f10e","491":"26cb46b6","500":"a1af602c","647":"d6865e90","662":"77271588","715":"cd905676","904":"f46927b2"}[chunkId] + ".chunk.js";
};